// extracted by mini-css-extract-plugin
export default {"root":"styles_root__c9nNF","tags":"styles_tags__5DkaC"};